var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sys-message" },
    [
      _c(
        "el-tooltip",
        { attrs: { content: _vm.tip } },
        [
          _c("svg-icon", {
            style: { fontSize: "20px", marginRight: _vm.number > 0 ? 0 : 10 },
            attrs: { "icon-class": "top_message" },
            on: { click: _vm.handleShowMessage }
          }),
          _c("span", { staticStyle: { color: "red", "padding-top": "10px" } }, [
            _vm._v(_vm._s(_vm.numberStr))
          ])
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "custom-class": "message-drawer",
            visible: _vm.drawerVisible,
            size: "650px"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("div", { staticClass: "title" }, [
                    _c("div", { staticClass: "title-left" }, [
                      _c("span", { staticClass: "title-tip" }, [
                        _vm._v(_vm._s(_vm.$t("Message.Message")))
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: { display: "flex", "margin-top": "6px" }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { size: "", no: "onlyUnread" },
                            on: { change: _vm.onlyUnReadChangeHandle },
                            model: {
                              value: _vm.onlyUnRead,
                              callback: function($$v) {
                                _vm.onlyUnRead = $$v
                              },
                              expression: "onlyUnRead"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "14px",
                                "margin-left": "3px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Message.OnlyUnRead")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "title-right" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "drawer-bell-btn-overlay",
                            attrs: { no: "Look" },
                            on: { click: _vm.btnAllMarksReadHandle }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.AllMarksRead")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "drawer-bell-btn-overlay",
                            attrs: { no: "Edit" },
                            on: { click: _vm.btnMsgClassifySetting }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.MessageConfig")))]
                        )
                      ],
                      1
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { staticClass: "classify" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 0 } },
                _vm._l(_vm.classifyMsgList, function(item, index) {
                  return _c(
                    "el-col",
                    { key: index, attrs: { span: 6 } },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: item.name,
                            placement: "bottom",
                            effect: "light"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.state,
                                  expression: "item.state"
                                }
                              ],
                              staticClass:
                                "classify-btn drawer-bell-btn-overlay",
                              class: {
                                "classify-select": index === _vm.classifySelect
                              },
                              style: {
                                borderRadius:
                                  index % 4 === 0
                                    ? "5px 0px 0px 5px"
                                    : index % 4 === 3
                                    ? "0px 5px 5px 0px"
                                    : index === _vm.classifyMsgList.length - 1
                                    ? "0px 5px 5px 0px"
                                    : "0px"
                              },
                              attrs: { size: "medium", plain: "" },
                              on: {
                                click: function($event) {
                                  return _vm.btnClassifyChange(item, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "classify-btn-container" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100px",
                                        display: "flex",
                                        "flex-direction": "column",
                                        "justify-content": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "classify-btn-container-tip"
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "classify-btn-container-number",
                                      staticStyle: { display: "inline-block" },
                                      style: {
                                        backgroundColor: item.number
                                          ? "#E47470"
                                          : "#65B687"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.number
                                            ? item.number > 99
                                              ? "99+"
                                              : item.number
                                            : 0
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "keyword-search",
              staticStyle: { display: "flex", padding: "15px 0" }
            },
            [
              _c("el-input", {
                staticStyle: { width: "60%", "margin-right": "10px" },
                attrs: {
                  no: "keyword",
                  placeholder: _vm.$t("Message.EnterKeyword")
                },
                model: {
                  value: _vm.searchKeyword,
                  callback: function($$v) {
                    _vm.searchKeyword = $$v
                  },
                  expression: "searchKeyword"
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    width: "230px",
                    "margin-right": "10px"
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "-",
                      "start-placeholder": _vm.$t("Pricing.StartTime"),
                      "end-placeholder": _vm.$t("Pricing.EndTime"),
                      "picker-options": _vm.pickerOptions,
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.searchDate,
                      callback: function($$v) {
                        _vm.searchDate = $$v
                      },
                      expression: "searchDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-right": "0px" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "align-items": "end" },
                      attrs: { no: "Look", type: "primary" },
                      on: { click: _vm.queryCurrentMsgNotify }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Query")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "body" }, [
            _c(
              "div",
              { staticClass: "table-content" },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.filterMsgTable(),
                      "show-header": false,
                      height: "100%",
                      stripe: ""
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    placement: "bottom",
                                    disabled: ""
                                  }
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "content" },
                                    domProps: {
                                      innerHTML: _vm._s(scope.row.content)
                                    },
                                    slot: "content"
                                  }),
                                  _c(
                                    "div",
                                    {
                                      style: { color: scope.row.color },
                                      on: {
                                        click: function($event) {
                                          return _vm.readMsgByMouseOrClick(
                                            scope.row
                                          )
                                        },
                                        mouseenter: function($event) {
                                          return _vm.msgMouseEnterHandle(
                                            scope.row
                                          )
                                        },
                                        mouseleave: function($event) {
                                          return _vm.msgMouseLeaveHandle(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("img", {
                                            staticStyle: { width: "15px" },
                                            attrs: {
                                              src: require("@/assets/icons/notify-action-company-x16.png")
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                fontWeight: !scope.row.readed
                                                  ? "bold"
                                                  : "400"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(scope.row.topic) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          scope.row && scope.row.link
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    float: "right"
                                                  },
                                                  attrs: { type: "success" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.btnShowDetailHandler(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_LookDetail"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(scope.row.content)
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "message-contents-footer" },
                  [
                    _c("cargo-pagination", {
                      attrs: {
                        total: _vm.msgList.total,
                        page: _vm.msgList.pageNum,
                        limit: _vm.msgList.pageSize
                      },
                      on: {
                        "update:page": function($event) {
                          return _vm.$set(_vm.msgList, "pageNum", $event)
                        },
                        "update:limit": function($event) {
                          return _vm.$set(_vm.msgList, "pageSize", $event)
                        },
                        pagination: _vm.queryCurrentMsgNotify
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "conf-dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.showEditDialog,
            title: _vm.$t("SystemMaintenance.BellSubscriptionTitle"),
            width: "750px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showEditDialog = $event
            },
            closed: _vm.cancelHandler
          },
          slot: "reference"
        },
        [
          _c("div", [
            _c("div", { staticClass: "conf-dialog-title" }, [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.BellSubscriptionConf")))
            ]),
            _c(
              "div",
              { staticClass: "conf-dialog-container" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 5 } },
                  _vm._l(_vm.confFrom, function(item, index) {
                    return _c(
                      "el-col",
                      { key: index, attrs: { span: 6 } },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: item.name,
                              placement: "bottom",
                              effect: "light"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "conf-dialog-container-col" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "conf-dialog-container-col-tip"
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                                _c(
                                  "div",
                                  [
                                    _c("el-switch", {
                                      staticClass:
                                        "conf-dialog-container-col-switch",
                                      attrs: {
                                        "active-color": "#13ce66",
                                        "inactive-color": "#EAECF0"
                                      },
                                      model: {
                                        value: item.state,
                                        callback: function($$v) {
                                          _vm.$set(item, "state", $$v)
                                        },
                                        expression: "item.state"
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item.state
                                            ? _vm.$t(
                                                "SystemMaintenance.BellSubscribed"
                                              )
                                            : _vm.$t(
                                                "SystemMaintenance.BellUnSubscribed"
                                              )
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "conf-dialog-title" }, [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.MessageConfig")))
            ]),
            _c(
              "div",
              { staticClass: "conf-dialog-container" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 1 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "conf-dialog-container-col",
                          staticStyle: { width: "200px" }
                        },
                        [
                          _c("img", {
                            staticClass: "conf-dialog-container-icon",
                            attrs: { src: require("@/assets/icons/wobao.png") }
                          }),
                          _c(
                            "span",
                            { staticClass: "conf-dialog-container-col-tip" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.WoBaoIntelligentAssistant"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            [
                              _c("el-switch", {
                                staticClass: "conf-dialog-container-col-switch",
                                attrs: {
                                  "active-color": "#13ce66",
                                  "inactive-color": "rgb(234,236,240)"
                                },
                                model: {
                                  value: _vm.woBaoConfFlag,
                                  callback: function($$v) {
                                    _vm.woBaoConfFlag = $$v
                                  },
                                  expression: "woBaoConfFlag"
                                }
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.woBaoConfFlag
                                      ? _vm.$t(
                                          "SystemMaintenance.WoBaoSubscribed"
                                        )
                                      : _vm.$t(
                                          "SystemMaintenance.WoBaoUnSubscribed"
                                        )
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            width: "190px",
                            "margin-left": "10px",
                            "margin-top": "-2px",
                            "line-height": "1.5"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#DCA550",
                              margin: "5px 5px 0 0"
                            }
                          }),
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SystemMaintenance.WoBaoSubscriptionTip")
                              )
                            )
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini ", type: "primary" },
                  on: { click: _vm.submitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini " }, on: { click: _vm.cancelHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }